import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionAnualidad";
import { PostCambiarVendedorMasivo } from "../../../reducers/comisionAnualidad";

export interface ReasignacionVendedorDispatcher {
  postCambiarVendedorMasivo: (
    formData: FormData,
    confirmar: boolean
  ) => Promise<Preview<PostCambiarVendedorMasivo>>;
}

export const reasignacionVendedorDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ReasignacionVendedorDispatcher = dispatch => ({
  postCambiarVendedorMasivo: (formData: FormData, confirmar: boolean) => {
    return dispatch(actions.postCambiarVendedorMasivo(formData, confirmar));
  }
});
